import { useState } from 'react';
import { BangTongHopHoaDonBanHangHoaDichVuProvider, useBangTongHopHoaDonBanHangHoaDichVuContext } from './context';
import { EditPrintTemplateDialog, LoadingExporting, ErpDataTableV2 } from '@/components/custom/erp';
import { useDialogState, useSearchLogic } from './hooks';
import SearchDialog from './components/SearchDialog';
import DocumentForm from './components/DocumentForm';
import { invoiceReportColumns } from './columns';
import { useReport, useRows } from '@/hooks';
import { ActionBar } from './components';
import { QUERY_KEYS } from '@/constants';

const PAGE_SIZE = 30;

function BangTongHopHoaDonBanHangContent() {
  const { getReport, isLoading, data, currentPage, handlePageChange, totalItems } = useReport({
    endpoint: QUERY_KEYS.BANG_TONG_HOP_HOA_DON_BAN_HANG,
    pageSize: PAGE_SIZE
  });

  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,
    handleInitialSearch: handleInitialSearchHook,
    handleRefreshClick: handleRefreshClickHook,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleFixedColumnsClick,
    searchFieldState,
    setSearchFieldState
  } = useDialogState();
  const { handleRowClick, selectedObj, setSelectedObj } = useRows();
  const { isExporting } = useBangTongHopHoaDonBanHangHoaDichVuContext();
  const {
    searchState,
    handleSearchChange,
    handleSearchPageChange,
    hasFilterParams,
    handleInitialSearch,
    handleRefreshClick,
    isSearching
  } = useSearchLogic({
    getReport,
    searchParams,
    showTable,
    handleInitialSearchHook
  });

  const [openDocumentForm, setOpenDocumentForm] = useState(false);
  const handleDocumentFormClick = (row: BanHangRecord) => {
    setSelectedObj(row);
    setOpenDocumentForm(true);
  };
  const resolvedRows = hasFilterParams ? searchState.searchResults : data;
  const resolvedCurrentPage = hasFilterParams ? searchState.currentPage : currentPage;
  const resolvedTotalItems = hasFilterParams ? searchState.totalCount : totalItems;
  const resolvedHandlePageChange = hasFilterParams ? handleSearchPageChange : handlePageChange;

  const tables = [
    {
      name: '',
      rows: resolvedRows || [],
      columns: invoiceReportColumns(handleDocumentFormClick)
    }
  ];

  return (
    <div className='flex h-screen w-screen flex-col lg:overflow-hidden'>
      {initialSearchDialogOpen && (
        <SearchDialog
          onClose={handleInitialSearchClose}
          onSearch={handleInitialSearch}
          initialValues={searchParams}
          initialSearchFieldState={searchFieldState}
          onSaveSearchFieldState={setSearchFieldState}
        />
      )}

      {openDocumentForm && selectedObj && (
        <DocumentForm
          document_uuid={selectedObj?.document_uuid}
          document_type={selectedObj?.document_type}
          onClose={() => setOpenDocumentForm(false)}
        />
      )}

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {isExporting && <LoadingExporting />}

      {showTable && !openDocumentForm && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            fromDate={searchParams.ngay_ct1 || ''}
            toDate={searchParams.ngay_ct2 || ''}
          />

          <div className='h-full overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                onRowClick={handleRowClick}
                totalItems={resolvedTotalItems}
                pageSize={PAGE_SIZE}
                currentPage={resolvedCurrentPage}
                onPageChange={resolvedHandlePageChange}
                loading={isLoading || isSearching}
                onSearchChange={handleSearchChange}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default function BangTongHopHoaDonBanHang() {
  return (
    <BangTongHopHoaDonBanHangHoaDichVuProvider>
      <BangTongHopHoaDonBanHangContent />
    </BangTongHopHoaDonBanHangHoaDichVuProvider>
  );
}
